import { takeEvery } from 'redux-saga/effects';
import { getType } from 'typesafe-actions';

import * as utilitiesActions from './actions';
import { apiSagaV2 } from '../../../helpers/saga';
import { AdminApi } from 'src/api';

const getUtilitiesListSaga = apiSagaV2(
  utilitiesActions.getUtilitiesList,
  async (connection, action) => {
    return new AdminApi(connection).getUtilitiesList();
  }
);

export function* utilitiesSaga() {
  yield takeEvery(getType(utilitiesActions.getUtilitiesList.request), getUtilitiesListSaga);
}
